var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.041 25.2083H20.6243V29.7916H16.041V25.2083ZM16.041 34.375H20.6243V38.9583H16.041V34.375ZM25.2077 25.2083H29.791V29.7916H25.2077V25.2083ZM25.2077 34.375H29.791V38.9583H25.2077V34.375ZM34.3743 25.2083H38.9577V29.7916H34.3743V25.2083ZM34.3743 34.375H38.9577V38.9583H34.3743V34.375Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4583 50.4166H43.5417C46.0694 50.4166 48.125 48.361 48.125 45.8333V13.75C48.125 11.2223 46.0694 9.16665 43.5417 9.16665H38.9583V4.58331H34.375V9.16665H20.625V4.58331H16.0417V9.16665H11.4583C8.93062 9.16665 6.875 11.2223 6.875 13.75V45.8333C6.875 48.361 8.93062 50.4166 11.4583 50.4166ZM43.5417 18.3333L43.544 45.8333H11.4583V18.3333H43.5417Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCalendar);
export default __webpack_public_path__ + "static/media/icon_calendar.c10abe1f21ab62d6e2af994398639ad5.svg";
export { ForwardRef as ReactComponent };